import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getMessageFromError } from "../../../shared/welda/services/utilsService";
import errorHandling from "../errorHandling";
import sqlService from "./SQLService";

const initialState = {
  getDataDropState: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
    data: null,
    extension: null,
    filename: null,
  },
  executeStoredProcedureState: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
    data: null,
  },
  getDataDropStateDEV: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
    data: null,
    extension: null,
    filename: null,
  },
  sqlUpdate: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
  },
  SalesInfoFixState: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
  },
  MOFdata: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    data: null,
  },
  Paymentsdata: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    data: null,
  },
  LopendeLVB: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    data: null,
    extraInfo: null,
  },
  OpenstaandeDoc: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    data: null,
  },
  updateOpenstaandeDoc: {
    isError: false,
    isSuccess: false,
    isLoading: false,
  },
  LopendeVKO: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    data: null,
  },
  LopendeHRB: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    data: null,
  },
  updateLopendeVKO: {
    isError: false,
    isSuccess: false,
    isLoading: false,
  },
  updateLopendeHRB: {
    isError: false,
    isSuccess: false,
    isLoading: false,
  },
  updateLopendeLVB: {
    isError: false,
    isSuccess: false,
    isLoading: false,
  },
  SalesData: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    data: null,
    accountingPerBkjOptions: [],
  },
  updateSalesData: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    queueHFAKOBJ: [],
  },
  openAI: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
  },
  FreqBoughtTogetherProducts: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    data: null,
  },
};

export const FreqBoughtTogetherProducts = createAsyncThunk(
  "sql/FreqBoughtTogetherProducts",
  async (data, thunkAPI) => {
    try {
      const result = await sqlService.FreqBoughtTogetherProducts(data);
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const formatElapsedTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (minutes > 0) {
    return `${minutes}m ${remainingSeconds}s`;
  }
  return `${remainingSeconds}s`;
};

export const updateSalesData = createAsyncThunk(
  "sql/AWTech/updateSalesData",
  async (data, thunkAPI) => {
    const { getState } = thunkAPI;
    const startTime = Date.now(); // Start timer

    // Determine count from payload or queue
    const queueCount =
      getState()?.sql?.updateSalesData?.queueHFAKOBJ?.length ?? 0;
    const dataCount = Array.isArray(data?.HFAKOBJS)
      ? data.HFAKOBJS.length
      : data?.HFAKOBJS
        ? 1
        : queueCount || undefined;

    const toastId = toast.loading(
      dataCount
        ? `Updaten van ${dataCount} document${dataCount > 1 ? "en" : ""
        }... (0s)`
        : "Marges updaten (0s)",
      {
        theme: "colored",
        type: "info",
        closeOnClick: false,
        closeButton: false,
        hideProgressBar: true,
      }
    );

    // Start interval to update timer in toast
    const timerInterval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const formattedTime = formatElapsedTime(elapsed);

      toast.update(toastId, {
        render: dataCount
          ? `Updaten van ${dataCount} document${dataCount > 1 ? "en" : ""
          }... (${formattedTime})`
          : `Marges updaten (${formattedTime})`,
        type: "info",
        isLoading: true,
        theme: "colored",
        closeOnClick: false,
        closeButton: false,
        hideProgressBar: true,
      });
    }, 1000);

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const result = await sqlService.updateSalesData(data);

      // Clear timer interval
      clearInterval(timerInterval);

      const totalTime = Math.floor((Date.now() - startTime) / 1000);
      const formattedTotalTime = formatElapsedTime(totalTime);

      toast.update(toastId, {
        render: `Update uitgevoerd (${formattedTotalTime})`,
        type: "success",
        isLoading: false,
        autoClose: 2000,
        theme: "colored",
        closeOnClick: true,
        icon: "✅",
      });

      return {
        result,
        update: data?.HFAKOBJS ? true : false,
      };
    } catch (error) {
      // Clear timer interval on error
      clearInterval(timerInterval);

      const totalTime = Math.floor((Date.now() - startTime) / 1000);
      const formattedTotalTime = formatElapsedTime(totalTime);

      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      errorHandling(error);

      toast.update(toastId, {
        render: `${message} (${formattedTotalTime})`,
        type: "error",
        isLoading: false,
        autoClose: 4000,
        theme: "colored",
        closeOnClick: true,
        icon: "⚠️",
      });

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateMarginCalculations = createAsyncThunk(
  "sql/updateMarginCalculations",
  async (thunkAPI) => {
    try {
      const result = await sqlService.updateMarginCalculations();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const AddManualTag = createAsyncThunk(
  "sql/salesData/addManualTag",
  async (data, thunkAPI) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const result = await sqlService.AddManualTag(data);
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const GetSalesData = createAsyncThunk(
  "sql/GetSalesData",
  async (filter, thunkAPI) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const result = await sqlService.GetSalesData(filter);
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateLopendeLVB = createAsyncThunk(
  "sql/updateLopendeLVB",
  async (thunkAPI) => {
    try {
      const result = await sqlService.updateLopendeLVB();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateLopendeVKO = createAsyncThunk(
  "sql/updateLopendeVKO",
  async (thunkAPI) => {
    try {
      const result = await sqlService.updateLopendeVKO();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateOpenstaandeDoc = createAsyncThunk(
  "sql/updateOpenstaandeDoc",
  async (thunkAPI) => {
    try {
      const result = await sqlService.updateOpenstaandeDoc();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateLopendeHRB = createAsyncThunk(
  "sql/updateLopendeHRB",
  async (thunkAPI) => {
    try {
      const result = await sqlService.updateLopendeHRB();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const LopendeVKO = createAsyncThunk(
  "sql/LopendeVKO",
  async (thunkAPI) => {
    try {
      const result = await sqlService.LopendeVKO();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const LopendeHRB = createAsyncThunk(
  "sql/LopendeHRB",
  async (thunkAPI) => {
    try {
      const result = await sqlService.LopendeHRB();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const Paymentsdata = createAsyncThunk(
  "sql/Paymentsdata",
  async (thunkAPI) => {
    try {
      const result = await sqlService.Paymentsdata();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const LopendeLVB = createAsyncThunk(
  "sql/LopendeLVB",
  async (thunkAPI) => {
    try {
      const result = await sqlService.LopendeLVB();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const OpenstaandeDoc = createAsyncThunk(
  "sql/OpenstaandeDoc",
  async (thunkAPI) => {
    try {
      const result = await sqlService.OpenstaandeDoc();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const MOFdata = createAsyncThunk("sql/MOFdata", async (thunkAPI) => {
  try {
    const result = await sqlService.MOFdata();
    return result;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    errorHandling(error);
    return thunkAPI.rejectWithValue(message);
  }
});

export const SalesInfoFix = createAsyncThunk(
  "sql/SalesInfoFix",
  async (thunkAPI) => {
    try {
      const result = await sqlService.SalesInfoFix();
      return result;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const sqlUpdate = createAsyncThunk("sql/sqlupdate", async (thunkAPI) => {
  try {
    const result = await sqlService.sqlUpdate();
    return result;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    errorHandling(error);
    return thunkAPI.rejectWithValue(message);
  }
});

export const getDataDrop = createAsyncThunk(
  "sql/getDataDrop",
  async (sqlData, thunkAPI) => {
    try {
      const awaitgetDataDrop = await sqlService.getDataDrop(sqlData);
      return awaitgetDataDrop;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const executeStoredProcedure = createAsyncThunk(
  "sql/executeStoredProcedure",
  async (sqlData, thunkAPI) => {
    const startTime = Date.now();

    const toastId = toast.loading(`Stored procedure uitvoeren... (0s)`, {
      theme: "colored",
      type: "info",
      closeOnClick: false,
      closeButton: false,
      hideProgressBar: true,
    });

    const timerInterval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const minutes = Math.floor(elapsed / 60);
      const seconds = elapsed % 60;
      const formattedTime =
        minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;

      toast.update(toastId, {
        render: `Stored procedure uitvoeren... (${formattedTime})`,
        type: "info",
        isLoading: true,
        theme: "colored",
        closeOnClick: false,
        closeButton: false,
        hideProgressBar: true,
      });
    }, 1000);

    try {
      const awaitExecuteStoredProcedure =
        await sqlService.executeStoredProcedure(sqlData);

      clearInterval(timerInterval);

      const totalTime = Math.floor((Date.now() - startTime) / 1000);
      const minutes = Math.floor(totalTime / 60);
      const seconds = totalTime % 60;
      const formattedTotalTime =
        minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;

      toast.update(toastId, {
        render: `Stored procedure voltooid (${formattedTotalTime})`,
        type: "success",
        isLoading: false,
        autoClose: 2000,
        theme: "colored",
        closeOnClick: true,
        icon: "✅",
      });

      return awaitExecuteStoredProcedure;
    } catch (error) {
      clearInterval(timerInterval);

      const totalTime = Math.floor((Date.now() - startTime) / 1000);
      const minutes = Math.floor(totalTime / 60);
      const seconds = totalTime % 60;
      const formattedTotalTime =
        minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;

      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);

      toast.update(toastId, {
        render: `${message} (${formattedTotalTime})`,
        type: "error",
        isLoading: false,
        autoClose: 4000,
        theme: "colored",
        closeOnClick: true,
        icon: "⚠️",
      });

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const openAI = createAsyncThunk(
  "sql/openAI",
  async (sqlData, thunkAPI) => {
    try {
      const awaitgetDataDrop = await sqlService.openAI(sqlData);
      toast.success(`${awaitgetDataDrop.length} resultaten`, {
        theme: "colored",
      });
      return awaitgetDataDrop;
    } catch (error) {
      console.error("ERROR!!");
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getDataDropDEV = createAsyncThunk(
  "sql/getDataDropDEV",
  async (sqlData, thunkAPI) => {
    try {
      const awaitgetDataDrop = await sqlService.getDataDropDEV(sqlData);
      return awaitgetDataDrop;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const sqlSlice = createSlice({
  name: "sql",
  initialState,
  reducers: {
    reset: (state) => {
      return initialState;
    },
    updateSalesDataAddToQueue(state, action) {
      const HFAKOBJ = action.payload;
      if (!state.updateSalesData.queueHFAKOBJ.includes(HFAKOBJ)) {
        state.updateSalesData.queueHFAKOBJ.push(HFAKOBJ);
      }
    },
    updateSalesDataRemoveFromQueue(state, action) {
      const HFAKOBJ = action.payload;
      state.updateSalesData.queueHFAKOBJ =
        state.updateSalesData.queueHFAKOBJ.filter((item) => item !== HFAKOBJ);
    },
    clearUpdateSalesDataQueue(state) {
      state.updateSalesData.queueHFAKOBJ = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateSalesData.pending, (state) => {
        state.updateSalesData.isLoading = true;
        state.updateSalesData.queueHFAKOBJ = [];
      })
      .addCase(updateSalesData.fulfilled, (state, action) => {
        state.updateSalesData.isLoading = false;
        state.updateSalesData.isSuccess = true;
        console.info("Update Sales Data Success:", action.payload);
        if (action.payload.update) {
          // Loop through all results and update records in SalesData by HFAKOBJ
          action.payload.result.forEach((resultItem) => {
            const index = state.SalesData.data.findIndex(
              (item) => item.HFAKOBJ === resultItem.HFAKOBJ
            );
            if (index !== -1) {
              state.SalesData.data[index] = resultItem;
            } else {
              state.SalesData.data.push(resultItem);
            }
          });
        } else {
          state.SalesData.data = action.payload.result;
        }
      })
      .addCase(updateSalesData.rejected, (state, action) => {
        state.updateSalesData.isLoading = false;
        state.updateSalesData.isError = true;
      })
      .addCase(GetSalesData.pending, (state) => {
        state.SalesData.isLoading = true;
        state.SalesData.data = null;
      })
      .addCase(GetSalesData.fulfilled, (state, action) => {
        state.SalesData.isLoading = false;
        state.SalesData.isSuccess = true;
        const payload = action.payload;
        if (Array.isArray(payload)) {
          state.SalesData.data = payload;
          state.SalesData.accountingPerBkjOptions = [];
        } else {
          state.SalesData.data = payload?.data ?? [];
          state.SalesData.accountingPerBkjOptions =
            payload?.accountingPerBkjOptions ?? [];
        }
      })
      .addCase(GetSalesData.rejected, (state, action) => {
        state.SalesData.isLoading = false;
        state.SalesData.isError = true;
      })
      .addCase(updateLopendeLVB.pending, (state) => {
        state.updateLopendeLVB.isLoading = true;
        state.updateLopendeLVB.data = null;
      })
      .addCase(updateLopendeLVB.fulfilled, (state, action) => {
        state.updateLopendeLVB.isLoading = false;
        state.updateLopendeLVB.isSuccess = true;
        state.LopendeLVB.data = action.payload;
      })
      .addCase(updateLopendeLVB.rejected, (state, action) => {
        state.updateLopendeLVB.isLoading = false;
        state.updateLopendeLVB.isError = true;
      })

      .addCase(updateLopendeVKO.pending, (state) => {
        state.updateLopendeVKO.isLoading = true;
        state.updateLopendeVKO.data = null;
      })
      .addCase(updateLopendeVKO.fulfilled, (state, action) => {
        state.updateLopendeVKO.isLoading = false;
        state.updateLopendeVKO.isSuccess = true;
        state.LopendeVKO.data = action.payload;
      })
      .addCase(updateLopendeVKO.rejected, (state, action) => {
        state.updateLopendeVKO.isLoading = false;
        state.updateLopendeVKO.isError = true;
      })
      .addCase(updateOpenstaandeDoc.pending, (state) => {
        state.updateOpenstaandeDoc.isLoading = true;
        state.updateOpenstaandeDoc.data = null;
      })
      .addCase(updateOpenstaandeDoc.fulfilled, (state, action) => {
        state.updateOpenstaandeDoc.isLoading = false;
        state.updateOpenstaandeDoc.isSuccess = true;
        state.OpenstaandeDoc.data = action.payload;
      })
      .addCase(updateOpenstaandeDoc.rejected, (state, action) => {
        state.updateOpenstaandeDoc.isLoading = false;
        state.updateOpenstaandeDoc.isError = true;
        state.OpenstaandeDoc.data = null;
      })
      .addCase(updateLopendeHRB.pending, (state) => {
        state.updateLopendeHRB.isLoading = true;
        state.updateLopendeHRB.data = null;
      })
      .addCase(updateLopendeHRB.fulfilled, (state, action) => {
        state.updateLopendeHRB.isLoading = false;
        state.updateLopendeHRB.isSuccess = true;
        state.LopendeHRB.data = action.payload;
      })
      .addCase(updateLopendeHRB.rejected, (state, action) => {
        state.updateLopendeHRB.isLoading = false;
        state.updateLopendeHRB.isError = true;
      })
      .addCase(LopendeVKO.pending, (state) => {
        state.LopendeVKO.isLoading = true;
        state.LopendeVKO.data = null;
      })
      .addCase(LopendeVKO.fulfilled, (state, action) => {
        state.LopendeVKO.isLoading = false;
        state.LopendeVKO.isSuccess = true;
        state.LopendeVKO.data = action.payload;
      })
      .addCase(LopendeVKO.rejected, (state, action) => {
        state.LopendeVKO.isLoading = false;
        state.LopendeVKO.isError = true;
        state.LopendeVKO.data = null;
      })
      .addCase(LopendeHRB.pending, (state) => {
        state.LopendeHRB.isLoading = true;
        state.LopendeHRB.data = null;
      })
      .addCase(LopendeHRB.fulfilled, (state, action) => {
        state.LopendeHRB.isLoading = false;
        state.LopendeHRB.isSuccess = true;
        state.LopendeHRB.data = action.payload;
      })
      .addCase(LopendeHRB.rejected, (state, action) => {
        state.LopendeHRB.isLoading = false;
        state.LopendeHRB.isError = true;
        state.LopendeHRB.data = null;
      })
      .addCase(LopendeLVB.pending, (state) => {
        state.LopendeLVB.isLoading = true;
        state.LopendeLVB.data = null;
        state.LopendeLVB.extraInfo = null;
      })
      .addCase(LopendeLVB.fulfilled, (state, action) => {
        state.LopendeLVB.isLoading = false;
        state.LopendeLVB.isSuccess = true;
        state.LopendeLVB.data = action.payload.lvbData;
        state.LopendeLVB.extraInfo = action.payload.extraInfo;
      })
      .addCase(LopendeLVB.rejected, (state, action) => {
        state.LopendeLVB.isLoading = false;
        state.LopendeLVB.isError = true;
        state.LopendeLVB.data = null;
        state.LopendeLVB.extraInfo = null;
      })
      .addCase(OpenstaandeDoc.pending, (state) => {
        state.OpenstaandeDoc.isLoading = true;
        state.OpenstaandeDoc.data = null;
      })
      .addCase(OpenstaandeDoc.fulfilled, (state, action) => {
        state.OpenstaandeDoc.isLoading = false;
        state.OpenstaandeDoc.isSuccess = true;
        state.OpenstaandeDoc.data = action.payload;
      })
      .addCase(OpenstaandeDoc.rejected, (state, action) => {
        state.OpenstaandeDoc.isLoading = false;
        state.OpenstaandeDoc.isError = true;
        state.OpenstaandeDoc.data = null;
      })
      .addCase(Paymentsdata.pending, (state) => {
        state.Paymentsdata.isLoading = true;
        state.Paymentsdata.data = null;
      })
      .addCase(Paymentsdata.fulfilled, (state, action) => {
        state.Paymentsdata.isLoading = false;
        state.Paymentsdata.isSuccess = true;
        state.Paymentsdata.data = action.payload;
      })
      .addCase(Paymentsdata.rejected, (state, action) => {
        state.Paymentsdata.isLoading = false;
        state.Paymentsdata.isError = true;
        state.Paymentsdata.data = null;
      })
      .addCase(MOFdata.pending, (state) => {
        state.MOFdata.isLoading = true;
        state.MOFdata.data = null;
      })
      .addCase(MOFdata.fulfilled, (state, action) => {
        state.MOFdata.isLoading = false;
        state.MOFdata.isSuccess = true;
        state.MOFdata.data = action.payload;
      })
      .addCase(MOFdata.rejected, (state, action) => {
        state.MOFdata.isLoading = false;
        state.MOFdata.isError = true;
        state.MOFdata.data = null;
      })
      .addCase(getDataDrop.pending, (state) => {
        state.getDataDropState.isLoading = true;
        state.getDataDropState.message = null;
      })
      .addCase(getDataDrop.fulfilled, (state, action) => {
        state.getDataDropState.isLoading = false;
        state.getDataDropState.isSuccess = true;
        state.getDataDropState.message = null;
      })
      .addCase(getDataDrop.rejected, (state, action) => {
        state.getDataDropState.isLoading = false;
        state.getDataDropState.isError = true;
        state.getDataDropState.message = action.payload;
      })
      .addCase(executeStoredProcedure.pending, (state) => {
        state.executeStoredProcedureState.isLoading = true;
        state.executeStoredProcedureState.message = null;
      })
      .addCase(executeStoredProcedure.fulfilled, (state, action) => {
        state.executeStoredProcedureState.isLoading = false;
        state.executeStoredProcedureState.isSuccess = true;
        state.executeStoredProcedureState.message = null;
        state.executeStoredProcedureState.data = action.payload.data;
      })
      .addCase(executeStoredProcedure.rejected, (state, action) => {
        state.executeStoredProcedureState.isLoading = false;
        state.executeStoredProcedureState.isError = true;
        state.executeStoredProcedureState.message = action.payload;
        state.executeStoredProcedureState.data = null;
      })
      .addCase(getDataDropDEV.pending, (state) => {
        state.getDataDropStateDEV.isLoading = true;
        state.getDataDropStateDEV.message = null;
      })
      .addCase(getDataDropDEV.fulfilled, (state, action) => {
        state.getDataDropStateDEV.isLoading = false;
        state.getDataDropStateDEV.isSuccess = true;
        state.getDataDropStateDEV.message = null;
      })
      .addCase(getDataDropDEV.rejected, (state, action) => {
        state.getDataDropStateDEV.isLoading = false;
        state.getDataDropStateDEV.isError = true;
        state.getDataDropStateDEV.message = action.payload;
      })
      .addCase(sqlUpdate.pending, (state) => {
        state.sqlUpdate.isLoading = true;
        state.sqlUpdate.message = null;
      })
      .addCase(sqlUpdate.fulfilled, (state, action) => {
        state.sqlUpdate.isLoading = false;
        state.sqlUpdate.isSuccess = true;
        state.sqlUpdate.message = null;
      })
      .addCase(sqlUpdate.rejected, (state, action) => {
        state.sqlUpdate.isLoading = false;
        state.sqlUpdate.isError = true;
        state.sqlUpdate.message = action.payload;
      })
      .addCase(SalesInfoFix.pending, (state) => {
        state.SalesInfoFixState.isLoading = true;
        state.SalesInfoFixState.message = null;
      })
      .addCase(SalesInfoFix.fulfilled, (state, action) => {
        state.SalesInfoFixState.isLoading = false;
        state.SalesInfoFixState.isSuccess = true;
        state.SalesInfoFixState.message = null;
      })
      .addCase(SalesInfoFix.rejected, (state, action) => {
        state.SalesInfoFixState.isLoading = false;
        state.SalesInfoFixState.isError = true;
        state.SalesInfoFixState.message = action.payload;
      })
      .addCase(openAI.pending, (state) => {
        state.openAI.isLoading = true;
        state.openAI.message = null;
      })
      .addCase(openAI.fulfilled, (state, action) => {
        state.openAI.isLoading = false;
        state.openAI.isSuccess = true;
        state.openAI.message = null;
      })
      .addCase(openAI.rejected, (state, action) => {
        state.openAI.isLoading = false;
        state.openAI.isError = true;
        state.openAI.message = action.payload;
      })
      .addCase(FreqBoughtTogetherProducts.pending, (state) => {
        state.FreqBoughtTogetherProducts.isLoading = true;
        state.FreqBoughtTogetherProducts.data = [];
      })
      .addCase(FreqBoughtTogetherProducts.fulfilled, (state, action) => {
        state.FreqBoughtTogetherProducts.isLoading = false;
        state.FreqBoughtTogetherProducts.isSuccess = true;
        state.FreqBoughtTogetherProducts.data = action.payload;
      })
      .addCase(FreqBoughtTogetherProducts.rejected, (state, action) => {
        state.FreqBoughtTogetherProducts.isLoading = false;
        state.FreqBoughtTogetherProducts.isError = true;
        state.FreqBoughtTogetherProducts.data = [];
      });
  },
});

export const {
  reset,
  updateSalesDataAddToQueue,
  updateSalesDataRemoveFromQueue,
  clearUpdateSalesDataQueue,
} = sqlSlice.actions;
export default sqlSlice.reducer;
